if (!customElements.get('article-quantity')) {
  customElements.define(
    'article-quantity',
    class ArticleQuantity extends HTMLElement {
      variantChangedUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.innerText = '';

          const variant = window.variantInventoryQuantities.find(v => v.id === event.data.variant.id);
          if (variant) {
            const paragraph = document.createElement('p');
            const stock = variant.inventory_quantity;
            if (stock > 10) {
              paragraph.classList.add('in-stock');
              paragraph.innerText = 'Auf Lager';
            } else if (stock > 0) {
              paragraph.classList.add('low-stock');
              paragraph.innerText = `Nur noch ${stock} Stück auf Lager!`;
            } else {
              paragraph.classList.add('out-of-stock');
              paragraph.innerText = 'Ausverkauft';
            }
            this.appendChild(paragraph);
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangedUnsubscriber) {
          this.variantChangedUnsubscriber();
        }
      }
    }
  );
}
